export default "__VITE_ASSET__2f77804d__"